import httpClient from './httpClient';
const prefix = 'vecabo'

export default {

  async createCompanyVecabo(body) {
    const { data } = await httpClient({ requiresAuth: true })
      .post(`${prefix}/createCompanyVecabo`, {
        body
      })

    return data
  },

  async createVecabo(body) {
    const { data } = await httpClient({ requiresAuth: true })
      .post(`${prefix}/createVecabo`, {
        body
      })

    return data
  },

  async createPermissionVecabo(body) {
    const { data } = await httpClient({ requiresAuth: true })
      .post(`${prefix}/createPermissionVecabo`, {
        body
      })

    return data
  }

}